/**
 * Portrait placeholder "illustrations" for mock chapter scenes (lot:
 * chapter scenes player). The real backend generates 1024x1536 WebP
 * images; mock mode has no image pipeline and must still work fully
 * offline (no network fetch to a placeholder service), so this draws a
 * flat-colour portrait SVG and inlines it as a `data:` URL — same trick as
 * `lib/coverArtwork.ts`'s `svgCoverToDataUrl`, and directly usable in
 * `<img src>` exactly like the real WebP URLs will be.
 */
const VIEWBOX_W = 683;
const VIEWBOX_H = 1024;

/** `bg`/`fg` are CSS colours (hex, keeps this independent of the app's own
 *  CSS custom properties, which an inline SVG data URL can't read anyway). */
export function mockChapterSceneUrl(label: string, bg: string, fg = "#f4efe6"): string {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${VIEWBOX_W} ${VIEWBOX_H}">`
    + `<rect width="${VIEWBOX_W}" height="${VIEWBOX_H}" fill="${bg}"/>`
    + `<circle cx="${VIEWBOX_W / 2}" cy="${VIEWBOX_H / 2 - 60}" r="120" fill="${fg}" opacity="0.9"/>`
    + `<text x="50%" y="${VIEWBOX_H / 2 + 160}" font-family="sans-serif" font-size="40" font-weight="700" `
    + `fill="${fg}" text-anchor="middle">${label}</text>`
    + "</svg>";
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}

/** Square stand-in for a pack's group portrait (three heroes): the real
 *  backend serves 1024px / 400px WebP, mock mode draws three flat
 *  silhouettes on the cover ground and inlines them as a `data:` URL. */
export function mockPackPortraitUrl(bg: string, fg = "#f4efe6"): string {
  const heads = [
    { cx: 300, cy: 470, r: 110 },
    { cx: 512, cy: 420, r: 130 },
    { cx: 724, cy: 470, r: 110 },
  ];
  const svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">'
    + `<rect width="1024" height="1024" fill="${bg}"/>`
    + heads.map(({ cx, cy, r }) =>
      `<circle cx="${cx}" cy="${cy}" r="${r}" fill="${fg}" opacity="0.9"/>`
      + `<ellipse cx="${cx}" cy="${cy + r + 190}" rx="${r * 1.5}" ry="${r * 1.4}" fill="${fg}" opacity="0.7"/>`).join("")
    + "</svg>";
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}
